import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import { IKanbanState } from './kanban-states.store';
import { KanbanState } from './kanban-states.store';
import mutations from './kanban-mutations.store';
import actions from './kanban-actions.store';
import getters from './kanban-getters.store';

export class KanbanModule<RootState> implements Module<IKanbanState, RootState>{
  namespaced: boolean;
  state: IKanbanState;
  getters: GetterTree<IKanbanState, RootState>;
  actions: ActionTree<IKanbanState, RootState>;
  mutations: MutationTree<IKanbanState>;

  constructor() {
    this.namespaced = true;
    this.state = new KanbanState();
    this.mutations = mutations;
    this.actions = actions;
    this.getters = getters;
  }
}

